// extracted by mini-css-extract-plugin
export default {"infoWrapper":"information-text_infoWrapper__JfBAa"};